import lrz from 'lrz';
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    listType: {
      type: String,
      default: 'picture-card'
    },
    isCompress: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: 10
    },

    config: {
      type: Object,
      default: function () {
        return {
        };
      }
    },
    limit: {
      type: Number,
      default: 10
    },
    title: {
      type: String,
      default: '上传照片'
    },
    image: {
      type: Array,
      default: function () {
        return [];
      }
    },
    category: {
      type: String,
      default: ''
    }
  },
  data: () => {
    return {
      imageLoading: false,
      imageUrl: '',
      imageError: '',
      hideUp: false,
      headers: {},
      action: 'api/v1.0/multiparts/images/upload',
      dialogImageUrl: '',
      imageList: [],
      dialogVisible: false,
      uploadData: {}
    };
  },

  watch: {
    category () {
      this.headers['x-rongxin-category']= this.category;
    },
    image(){
      if (this.image.length >= this.limit) {
        this.hideUp = true;
      }
    }
  },

  created() {
    this.headers['x-rongxin-category']= this.category;
  },

  methods: {
    imageBeforeUpload(file) {
      this.imageError = '';
      const arr = ['jpg', 'jpeg', 'png'];
      if (!arr.find(item => file.type.indexOf(item) !== -1)) {
        this.imageError = '图片只能是jpg，jpeg，png格式!';
        return false;
      }
      if (file.size / 1024 / 1024 > this.size) {
        this.imageError = '图片大小不能超过' + this.size + 'M';
        return false;
      }
      console.log(file);
      const isSize = new Promise((resolve, reject) => {
        const _URL = window.URL || window.webkitURL;
        const img = new Image();
        img.onload = () => {
          const imgWidth = img.width;
          const imgHight = img.height;
          if (!this.config.width || !this.config.height) {
            this.uploadData.width = Math.floor(imgWidth);
            this.uploadData.height = Math.floor(imgHight);
            return resolve();
          }
          this.uploadData.width = Math.floor(this.config.width);
          this.uploadData.height = Math.floor(this.config.height);
          let valid = imgWidth === this.config.width && imgHight === this.config.height;
          valid ? resolve(true) : reject(false);
        };
        img.src = _URL.createObjectURL(file);
      }).then(() => {
        // 图片在大于1M的时候进行压缩
        if (this.isCompress && (file.size / 1024 / 1024) > 1) {
          console.log('【压缩前】', file);
          const newFile = this.imgCompress(file);
          console.log('【压缩后】', newFile);
          return newFile;
        } else {
          return file;
        }
      }, () => {
        this.imageError = '请上传正确的图片尺寸';
        return Promise.reject(false);
      });
      return isSize;
    },

    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },

    dataURLtoFile2(Blob, filename) {
      return new File([Blob], filename, { type: Blob.type });
    },

    imgCompress(file) {
      const reference = this.$refs.uploadImage;
      let file_index = -1;
      reference.uploadFiles.forEach((item, index) => {
        if (item.raw === file) {
          file_index = index;
          return;
        }
      });
      // let index = reference.uploadFiles.indexOf(file);
      console.log(reference, file_index);

      return lrz(file).then(rst => {
        console.log('【图片压缩成功】', rst);
        // let tempFile = this.dataURLtoFile(rst.base64, rst.origin.name);
        let tempFile = this.dataURLtoFile2(rst.file, rst.origin.name);
        // tempFile.uid = rst.origin.uid;
        // reference.uploadFiles[file_index].raw = tempFile;
        // reference.uploadFiles[file_index].size = rst.fileLen;

        console.log('【新文件】', tempFile, reference);
        return tempFile;
        // this.$refs.imageUploadRef.submit();
      }).catch(function(error) {
        console.log('【图片压缩失败】', error);
      }).always(function() {
      });
    },

    changeImage(file, fileList) {
      this.hideUp = fileList.length >= this.limit;
    },

    previewPhotoItem(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    removePhotoItem(file, fileList) {
      console.log('【delete】：'+file, fileList);
      const list = fileList.map(item => {
        return (item.response && item.response[0]) ? item.response[0] : { image: {url: item.image.url}};
      });
      this.hideUp = list.length >= this.limit;
      this.$emit('upload', list);
    },

    handleExceed() {
      this.hideUp = true;
    },

    handleUpSuccess(response, file, fileList) {
      console.log(123, response);
      // console.log('【handleUpSuccess】', fileList);
      this.hideUp = fileList.length >= this.limit;
      const list = fileList.map(item => {
        const image = item.response && item.response[0];
        // 此为编辑图片
        if(!image && item.url) {
          return {
            image: {
              url: item.ossUrl || item.url
            }
          };
        }
        return {
          image: {
            url: (image && image.image) ? image.image.url: item.image.url,
            Fullurl: (image && image.image) ? image.image.fullpath: item.fullpath
          }
        };
      });
      this.$emit('upload', list);
    },

    handleUpError(error) {
      this.imageError = error.reason;
    },

    clearImage() {
      this.$refs['uploadImage'].clearFiles();
      this.hideUp = false;
    }
  }
};

